<template>
  <div class="hikitsugi-end-date edit-item" v-if="editingData">

    <div class="head"><b>引継期間終了日</b></div>
    <div class="data">
      <date-picker v-model="editingData.hikitsugi_end_date" :clearable="false"
      :error="getError(editingData, 'hikitsugi_end_date')" :disabled="disabled"></date-picker>
    </div>
    
  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();
    return {
      getError
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
